import { createActionGroup, props } from '@ngrx/store';

export const WorkflowActions = createActionGroup({
  source: 'Workflow',
  events: {
    'Warm Project': props<{ projectId: string }>(),
    'Board Loaded': props<{ columns: any[] }>(),
  },
});
